import { Box, Tooltip } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import RenderChip from 'components/RenderChipComponents/RenderChip'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface TypeCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const TypeCell: FC<TypeCellProps> = ({ params, densityStyles }) => {
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Tooltip title={params?.value}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          padding: densityStyles.padding,
          gap: densityStyles.gap,
          cursor: 'default',
        }}
      >
        <RenderChip
          type={Array.isArray(params.value) ? params.value[0] : params.value}
          height={densityStyles.chipHeight}
          width={densityStyles.chipWidth}
        />
      </Box>
    </Tooltip>
  )
}
export default TypeCell
